import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import { theme } from './styles/themes/theme';
import GlobalStyles from './styles/GlobalStyles';
import MainLayout from './layouts/MainLayout';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import HomePage from './pages/HomePage';
import SkillsPage from './pages/SkillsPage';
import ParcoursPage from './pages/ParcoursPage';
import FormationsPage from './pages/FormationsPage';
import ContactPage from './pages/ContactPage';
import CVPage from './pages/CVPage';
import PortfolioPage from './pages/PortfolioPage';
import { LayoutProvider } from './context/LayoutContext';

const App: React.FC = () => {
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      <LayoutProvider>
        <Router>
          <ScrollToTop />
          <MainLayout>
            <Navbar />
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/competences" element={<SkillsPage />} />
              <Route path="/parcours" element={<ParcoursPage />} />
              <Route path="/formations" element={<FormationsPage />} />
              <Route path="/portfolio" element={<PortfolioPage />} />
              <Route path="/cv" element={<CVPage />} />
              <Route path="/contact" element={<ContactPage />} />
            </Routes>
            <Footer />
          </MainLayout>
        </Router>
      </LayoutProvider>
    </ThemeProvider>
  );
};

export default App;
